const DEFAULT_CURRENCY_FORMATTER = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const SUPPORTED_FRACTION_DIGITS = Array.from({ length: 21 }, (_, fractionDigits) => fractionDigits);

const CURRENCY_FORMATTERS_BY_FRACTION_DIGITS = new Map(
  SUPPORTED_FRACTION_DIGITS.map((fractionDigits) => [
    fractionDigits,
    new Intl.NumberFormat(undefined, {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }),
  ])
);

/**
 * Форматирует число как валюту (без символа валюты)
 * Использует локаль браузера
 * @param value - число для форматирования
 * @param fractionDigits - количество знаков после запятой (по умолчанию 0-2)
 */
export function formatCurrency(value: number, fractionDigits?: number): string {
  if (fractionDigits === undefined) {
    return DEFAULT_CURRENCY_FORMATTER.format(value);
  }

  const formatter = CURRENCY_FORMATTERS_BY_FRACTION_DIGITS.get(fractionDigits);
  if (!formatter) {
    throw new RangeError("fractionDigits must be between 0 and 20");
  }

  return formatter.format(value);
}
